<template>
  <v-container class="py-0">
    <v-row justify="center" align="stretch">
      <!-- TODO: Refactor all this to get rid of redundant code...
            if, in fact, any of this isn't thrown out. -->


      <v-col
      v-for="benefit in benefitsArray"
      :key="benefit.title"
      cols="12" md="4"
      class="py-1
      px-0 px-md-1"
      >
        <v-hover>
          <template v-slot="{ hover }">
            <v-card width="100%" height="100%" class="pa-2" :elevation="hover ? 30 : 6">
              <v-img
                :src="require(`@/assets/img/benefits/${benefit.name}/3x.jpg`)"
                :lazy-src="require(`@/assets/img/benefits/${benefit.name}/1x.jpg`)"
                :srcset="`${require(`@/assets/img/benefits/${benefit.name}/1x.jpg`)} 150w,
                            ${require(`@/assets/img/benefits/${benefit.name}/2x.jpg`)} 300w,
                            ${require(`@/assets/img/benefits/${benefit.name}/3x.jpg`)} 450w,
                            ${require(`@/assets/img/benefits/${benefit.name}/4x.jpg`)} 600w,
                            ${require(`@/assets/img/benefits/${benefit.name}/5x.jpg`)} 750w`"
                gradient="rgba(255, 255, 255, .1), rgba(0, 0, 0, .85) 70%"
                class="white--text align-end"
                :height="imgHeight"
              >
                <v-card-title class="text-h4 mb-0 pb-1 title-fix">
                  {{ benefit.title }}
                </v-card-title>
              </v-img>
              <v-card-subtitle class="py-2 text-overline accent2--text font-weight-bold
              condensed ">
                {{ benefit.subtitle }}
              </v-card-subtitle>
              <v-card-text class="text-body-1 text--primary info--text">
                {{ benefit.text }}
              </v-card-text>
            </v-card>
          </template>
        </v-hover>
      </v-col>

      <!-- First benefit: sound better -->
      <!-- <v-col cols="12" sm="4">
        <v-hover>
          <template v-slot="{ hover }">
            <v-card width="100%" height="100%" class="pa-2" :elevation="hover ? 30 : 6">
              <v-img
                src="@/assets/img/benefits/feature 01 (cropped).jpg"
                gradient="rgba(255, 255, 255, .1), rgba(0, 0, 0, .85) 70% "
                class="white--text align-end"
                :height="imgHeight"
              >
                <v-card-title class="display-1 mb-0 pb-1 title-fix">
                  Pitch-Perfect Accuracy
                </v-card-title>
              </v-img>
              <v-card-subtitle class="py-1 overline accent--text font-weight-bold">
                Every fret is precision cut and placed
              </v-card-subtitle>
              <v-card-text class="text--primary info--text">
                Play perfectly tuned chords! Every note under every string is tuned precisely. Our
                computer-controlled machining processes deliver accurate fret placement within
                0.1mm, perfectly setting the string length for every note, so your chords are tuned
                to harmonic perfection.
              </v-card-text>
            </v-card>
          </template>
        </v-hover>

      </v-col> -->

      <!-- Second benefit: be more versatile -->
      <!-- <v-col cols="12" sm="4">
        <v-card width="100%" height="100%" class="pa-2">
          <v-img
            src="@/assets/img/benefits/feature 02 (cropped).jpg"
            gradient="rgba(255, 255, 255, .1), rgba(0, 0, 0, .85) 70% "
            class="white--text align-end"
            :height="imgHeight"
          >
            <v-card-title class="display-1 mb-0 pb-1 title-fix">
              Fast and Easy Swappability
            </v-card-title>
          </v-img>
          <v-card-subtitle class="py-1 overline accent--text font-weight-bold">
            Interchangeable boards mean you’re not tied down
          </v-card-subtitle>
          <v-card-text class="text--primary info--text">
            Switch fretboards in a matter of seconds! Our patented magnetic attachment system means
            that there are no moving parts to break or rattle as you play. And our patent pending
            guide track system guarantees that the fretboard locks into the exact right spot every
            single time.
          </v-card-text>
        </v-card>
      </v-col> -->

      <!-- Third benefit: discover new stuff -->
      <!-- <v-col cols="12" sm="4">
        <v-card width="100%" height="100%" class="pa-2">
          <v-img
            src="@/assets/img/benefits/feature 03 (cropped).jpg"
            gradient="rgba(255, 255, 255, .1), rgba(0, 0, 0, .85) 70% "
            class="white--text align-end"
            :height="imgHeight"
          >
            <v-card-title class="display-1 mb-0 pb-1 title-fix">
              Explore New Sonorities
            </v-card-title>
          </v-img>
          <v-card-subtitle class="py-1 overline accent--text font-weight-bold">
            What have you been missing?
          </v-card-subtitle>
          <v-card-text class="text--primary info--text">
            A whole constellation of tuning systems are available for you to experiment with and
            create new music. Get a fretboard for common chords, or experiment with Indian Ragas and
            Just Intonation. Swap fretboards for different tuning systems, or just stick with the
            one that you love!
          </v-card-text>
        </v-card>
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      imgHeight: '250',
      benefitsArray: [
        {
          name: 'feat1',
          title: 'Pitch-Perfect Accuracy',
          subtitle: 'Every fret is precision cut and placed',
          text: `Play perfectly tuned chords! Every note under every string is tuned precisely. Our
                computer-controlled machining processes deliver accurate fret placement within
                0.1mm, perfectly setting the string length for every note, so your chords are tuned
                to harmonic perfection.`,
        },
        {
          name: 'feat2',
          title: 'Fast and Easy Swappability',
          subtitle: 'Interchangeable boards mean you’re not tied down',
          text: `Switch fretboards in a matter of seconds! Our patented magnetic attachment system means
            that there are no moving parts to break or rattle as you play. And our patented ending
            guide track system guarantees that the fretboard locks into the exact right spot every
            single time.`,
        },
        {
          name: 'feat3',
          title: 'Explore New Sonorities',
          subtitle: 'What have you been missing?',
          text: `A whole constellation of tuning systems are available for you to experiment with and
            create new music. Get a fretboard for common chords, or experiment with Indian Ragas and
            Just Intonation. Swap fretboards for different tuning systems, or just stick with the
            one that you love!`,
        },
      ],
    };
  },
};
</script>

<style>
.condensed {
  line-height: 1.4rem !important;
}
</style>
